import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { SelectorTreeDataProvider } from './providers/selectorTreeDataProvider';
import { Product } from '../shared/models';
import { RouteNames, RouteRedirector } from '../shared/providers';

@Injectable({
  providedIn: 'root'
})
export class SkipSelectorGuard implements CanActivate {

  constructor(private treeDataService: SelectorTreeDataProvider, private routeRedirector: RouteRedirector) { }

  canActivate():
    | boolean
    | Promise<boolean>
    | Observable<boolean> {

    // Use the service method you already wrote
    return this.treeDataService.hasOnlySingleProduct().then((product: Product | null) => {
      if (product) {
        // Block selector route if a single product exists
        // If there is only a single product, redirect to editor of that product.
        let params: any = {}
        params.productId = product.longId;
        params.view = RouteNames.Editor;
        return this.routeRedirector.redirectToEditor(params);        
      }

      // Allow route activation (selector page) otherwise
      return true;
    });
  }
}
